import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tooltip: {
            background: theme.palette.secondary[400],
            color: theme.palette.common.white,
        },
        arrow: {
            color: theme.palette.secondary[400],
        },
        tooltipWithContent: {
            backgroundColor: `${theme.palette.common.white} !important`,
            maxWidth: '424px !important',
            width: 'auto',
            boxShadow: `0px 0px 37px -15px ${theme.palette.secondary[700]} !important`,
            borderRadius: '10px !important',
            padding: '14px 12px !important',
            color: `${theme.palette.common.black} !important`,
        },
        arrowWithContent: {
            color: `${theme.palette.common.white} !important`,
        },
    }
})

export default useStyles
